import React from "react";
import AddEntityPopup from "components/Records/NewRecordPages/AddEntityPopup";
import { communityAPI } from "api/Community/CommunityAPI";

interface AddCommunityPopupProps {
  open: boolean;
  onClose: () => void;
  onSaved?: (newCommunity: any) => void;
}

const AddCommunityPopup: React.FC<AddCommunityPopupProps> = ({ open, onClose, onSaved }) => {
  return (
    <AddEntityPopup
      open={open}
      onClose={onClose}
      title="Add New Community"
      createFunction={communityAPI.create as (data: Record<string, any>) => Promise<any>}
      fields={[
        { name: "name", label: "Community Name", required: true },
        { name: "description", label: "Description", multiline: true, rows: 3 },
      ]}
      onSaved={onSaved}
    />
  );
};

export default AddCommunityPopup;
